export function mod(n: number, m: number) {
  return ((n % m) + m) % m;
}
